import { CraneActionKey, AlertDefinitionKey } from "./data/keys";
import type { WidgetKey } from "./data/widgets";

export interface Alert {
  id: string;
  definitionId: AlertDefinitionKey; // References the alert definition
  timestamp: string;
  acknowledged: boolean;
  // Epoch milliseconds when the alert was created (used for sorting/freshness)
  createdAt: number;
  // Set to true when user interacts (acknowledge, view details, add suggested widget)
  interacted: boolean;
  suggestedWidget?: WidgetKey;
}

export interface Widget {
  id: string;
  type: WidgetKey;
  alerts: number;
  warnings: number;
}

export enum BLOCK_POSITION {
  MID_RANGE = "Mid-range",
  PRE_HIGH = "Pre-high",
  HIGH = "High",
}

export interface CraneParameters {
  swl: number;
  swlPercentage: number;
  speed: number;
  // Speed limits in percent
  speedMin: number;
  speedMax: number;
  // Individual motion speeds (percent of max) - invisible in UI
  boomSpeed?: number;
  slewSpeed?: number;
  mhLoad: number;
  maxRadius: number;
  blockPosition: BLOCK_POSITION;
  absTravel: number;
  relTravel: number;
  windSpeed: number;
  slewAngle: number;
  boomAngle: number;
  // Angle limits for indicators
  boomMaxAngle: number;
  boomMinAngle: number;
  slewMaxAngle: number;
  slewMinAngle: number;
}

export interface CraneAction {
  type: "increment" | "decrement" | "set";
  parameter: keyof CraneParameters;
  value?: number;
  amount?: number;
}

export interface KeyMapping {
  key: string;
  action: CraneAction;
  description: string;
}

export interface ProcedureDefinition {
  id: string;
  name: string;
  description?: string;
  actions: CraneActionKey[];
}

export interface AlertDefinition {
  id: string;
  type: "error" | "warning" | "info" | "critical";
  title: string;
  message: string;
  category: string;
  priority: number;
  suggestedWidget?: WidgetKey;
  autoAcknowledgeAfter?: number;
}

export const ACTIONS = {
  OPEN_WIZARD: "OPEN_WIZARD",
  CLOSE_WIZARD: "CLOSE_WIZARD",
  ACKNOWLEDGE_ALERT: "ACKNOWLEDGE_ALERT",
  ADD_ALERT: "ADD_ALERT",
  OPEN_NOTIFICATIONS: "OPEN_NOTIFICATIONS",
  CLOSE_NOTIFICATIONS: "CLOSE_NOTIFICATIONS",
  SET_FILTER: "SET_FILTER",
} as const;
